import Paths from './paths';
import EnterprisePage from '@pages/EnterprisesPage';
import UsersPage from '@pages/UsersPage';
import {
  UserIcon,
  BuildingOfficeIcon,
  BuildingOffice2Icon,
  RectangleStackIcon,
  IdentificationIcon,
  Cog8ToothIcon,
  BellIcon,
  PlusCircleIcon,
} from '@heroicons/react/24/outline';

import LoginPage from '@pages/LoginPage';
import CreateEnterprisePage from '@enterprise/pages/CreateEnterprisePage';
import EditEnterprisePage from '@enterprise/pages/EditEnterprisePage';
import CVVideosPage from '@pages/CVVideosPage';
import { PlayIcon } from '@heroicons/react/24/solid';
import CreateUserPage from '@/modules/users/pages/CreateUserPage';
import { EditUserPage } from '@/modules/users/pages/EditUserPage';
import EstablishmentsPage from '@pages/EstablishmentsPage';
import CvVideoDetails from '@cv-videos/pages/CvVideoDetails';
import CreateEstablishmentPage from '@establishment/pages/CreateEstablishmentPage';
import EditEstablishmentPage from '@establishment/pages/EditEstablishmentPage';
import JobsPage from '@pages/JobsPage';
import JobDetails from '@jobs/pages/JobDetails';
import CandidatesPage from '@pages/CandidatesPage';
import SettingsPage from '@pages/SettingsPage';
import CandidateDetails from '@candidates/pages/CandidateDetails';
import NotificationsPage from '@pages/NotificationsPage';
import ForgotPasswordPage from '@pages/ForgotPasswordPage';
import ResetPasswordPage from '@pages/ResetPasswordPage';
import CreditsPage from '@pages/CreditsPage';
import CreateTopUpsPage from '@/modules/credits/pages/CreateTopUpsPage';
import DetailsTopUpsPage from '@/modules/credits/pages/DetailsTopUp';

export enum dividerPosition {
  'top' = 'top',
  'bottom' = 'bottom',
}

interface Route {
  path: string;
  component: React.ReactNode;
  label?: string;
  withSideBar: boolean;
  displayOnSideBar: boolean;
  private: boolean;
  icon?: React.JSX.Element;
  withCounter?: boolean;
  divider?: dividerPosition;
}

const routes: Route[] = [
  {
    label: 'LOGIN',
    path: Paths.LoginPage,
    withSideBar: false,
    displayOnSideBar: false,
    private: false,
    component: <LoginPage />,
  },
  {
    label: 'NOTIFICATIONS',
    path: Paths.NotificationsPage,
    displayOnSideBar: true,
    withSideBar: true,
    private: true,
    component: <NotificationsPage />,
    icon: <BellIcon />,
    withCounter: true,
  },
  {
    label: 'FORGOT_PASSWORD',
    path: Paths.ForgotPassword,
    withSideBar: false,
    displayOnSideBar: false,
    private: false,
    component: <ForgotPasswordPage />,
  },
  {
    label: 'RESET_PASSWORD',
    path: Paths.ResetPassword,
    withSideBar: false,
    displayOnSideBar: false,
    private: false,
    component: <ResetPasswordPage />,
  },
  {
    label: 'CV_VIDEOS',
    path: Paths.CvVideos,
    displayOnSideBar: true,
    withSideBar: true,
    private: true,
    component: <CVVideosPage />,
    icon: <PlayIcon />,
    withCounter: true,
  },
  {
    path: Paths.CvVideoDetails,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <CvVideoDetails />,
  },
  {
    label: 'ENTERPRISES',
    path: Paths.EnterprisePage,
    displayOnSideBar: true,
    withSideBar: true,
    private: true,
    component: <EnterprisePage />,
    icon: <BuildingOffice2Icon />,
  },
  {
    label: 'NEW_ENTERPRISE',
    path: Paths.CreateEnterprise,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <CreateEnterprisePage />,
  },
  {
    label: 'EDIT_ENTERPRISE',
    path: Paths.EditEnterprise,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <EditEnterprisePage />,
  },
  {
    label: 'ESTABLISHMENTS',
    path: Paths.EstablishmentPage,
    displayOnSideBar: true,
    withSideBar: true,
    private: true,
    component: <EstablishmentsPage />,
    icon: <BuildingOfficeIcon />,
  },
  {
    label: 'NEW_ESTABLISHMENT',
    path: Paths.CreateEstablishment,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <CreateEstablishmentPage />,
  },
  {
    label: 'EDIT_ESTABLISHMENT',
    path: Paths.EditEstablishment,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <EditEstablishmentPage />,
  },

  {
    label: 'USERS',
    path: Paths.UsersPage,
    displayOnSideBar: true,
    withSideBar: true,
    private: true,
    component: <UsersPage />,
    icon: <UserIcon />,
  },
  {
    label: 'CREATE_USER',
    path: Paths.CreateUser,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <CreateUserPage />,
    icon: <UserIcon />,
  },
  {
    label: 'EDIT_USER',
    path: Paths.EditUser,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <EditUserPage />,
  },
  {
    label: 'JOBS',
    path: Paths.JobsPage,
    displayOnSideBar: true,
    withSideBar: true,
    private: true,
    component: <JobsPage />,
    icon: <RectangleStackIcon />,
  },
  {
    label: 'JOBS_DETAILS',
    path: Paths.JobsDetails,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <JobDetails />,
  },
  {
    label: 'CANDIDATES',
    path: Paths.CandidatePage,
    displayOnSideBar: true,
    withSideBar: true,
    private: true,
    component: <CandidatesPage />,
    icon: <IdentificationIcon />,
  },
  {
    label: 'CANDIDATES_DETAILS',
    path: Paths.CandidateDetails,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <CandidateDetails />,
  },
  {
    label: 'SETTINGS',
    path: Paths.SettingsPage,
    displayOnSideBar: true,
    withSideBar: true,
    private: true,
    component: <SettingsPage />,
    icon: <Cog8ToothIcon />,
  },
  {
    label: 'CREDITS',
    path: Paths.CreditsPage,
    displayOnSideBar: true,
    withSideBar: true,
    private: true,
    component: <CreditsPage />,
    icon: <PlusCircleIcon />,
    divider: dividerPosition.top,
  },
  {
    label: 'CREATE_TOP_UPS',
    path: Paths.CreateTopUps,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <CreateTopUpsPage />,
    icon: <></>,
  },
  {
    label: 'DETAILS_TOP_UPS',
    path: Paths.DetailsTopUps,
    displayOnSideBar: false,
    withSideBar: true,
    private: true,
    component: <DetailsTopUpsPage />,
    icon: <></>,
  },
];

export default routes;
